import React from 'react';
import { ExternalLink } from 'lucide-react';
import styles from '../SocialContact.module.css';
import type { quickLink } from '../types.props';

interface quickLinkCardProps {
    link: quickLink;
    onClick: (url: string) => void;
}

export const QuickLinkCard: React.FC<quickLinkCardProps> = ({ link, onClick }) => {
    const IconComponent = link.icon;

    return (
        <article
            className={`${styles["card-base"]} ${styles.quickLinkCard}`}
            onClick={() => onClick(link.url)}
            role="button"
            tabIndex={0}
            aria-label={`Visitar ${link.name}: ${link.description}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(link.url);
                }
            }}
        >
            <div className={styles["quick-link-content"]}>
                <div className={styles["quick-link-icon-wrapper"]}>
                    <IconComponent size={24} color="#ffffff" />
                </div>
                <div className={styles["quick-link-text-wrapper"]}>
                    <h3 className={styles["quick-link-title"]}>{link.name}</h3>
                    <p className={styles["quick-link-description"]}>{link.description}</p>
                </div>
                <div className={styles["external-icon"]}>
                    <ExternalLink size={20} />
                </div>
            </div>
            <div className={styles.overlay} />
        </article>
    );
};
